import React, {
    useEffect, useState, useContext, useCallback
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './PolicyCommonDetails.metadata.json5';
import styles from './PolicyCommonDetails.module.scss';
import messages from './PolicyCommonDetails.messages';


function PolicyCommonDetails(props) {
    const { value: policyCommonDetails } = props;
    const translator = useContext(TranslatorContext);

    const getPolHolderName = (polCommonDetails) => {
        const contacts1 = polCommonDetails.contacts;
        let insuredContact = {};
        if (contacts1 != null) {
            _.each(contacts1, (contact) => {
                if (contact.contactRole === 'Primary Named Insured') {
                    insuredContact = contact.contact;
                }
            });
        }
        return (
            <div>
                {insuredContact.displayName}
            </div>
        );
    };

    const getPolStatusName = (polCommonDetails) => {
        const status = polCommonDetails.policyStatusDisplay;
        let displayStatus = '';
        switch (status) {
            case ('In Force'):
                displayStatus = translator(messages.active);
                break;
            default:
                displayStatus = status;
        }
        return displayStatus;
    };

    const overrides = {
        commonDetailsSection: {
            content: translator(messages.commonDetailsSection, {
                polNumber: policyCommonDetails.policyNumber
            })
        },
        policyHolderValue: {
            value: getPolHolderName(policyCommonDetails)
        },
        policyStatusValue: {
            value: getPolStatusName(policyCommonDetails)
        },
        nextPaymentAmount: {
            value: policyCommonDetails.policyBillingSummary.nextPaymentAmount.amount == 0 ? '-' : policyCommonDetails.policyBillingSummary.nextPaymentAmount
        }

    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={policyCommonDetails}
            overrideProps={overrides}
            classNameMap={styles}
        />
    );
}

PolicyCommonDetails.propTypes = {
    value: PropTypes.shape({})
};

PolicyCommonDetails.defaultProps = {
    value: {}
};

export default PolicyCommonDetails;
